import './App.css';
import {
  Navbar,
  Landing,
  AboutMe,
  Technologies,
  Portfolio,
  Contact,
} from './screens';

function App() {
  return (
    <div className='wrapper'>
      <Navbar />
      <main>
        <Landing />
        <AboutMe />
        <Technologies />
        <Portfolio />
      </main>
      <Contact />
    </div>
  );
}

export default App;
